import { CommonModule, NgFor } from '@angular/common';
import { Component, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'formly-field-input',
    imports: [MatInputModule, ReactiveFormsModule, MatSelectModule, CommonModule, NgFor, MatOptionModule],
    template: `
    <mat-form-field class="w-full" appearance="outline">
        <mat-label>{{ to.label }}</mat-label>
        <mat-select [formControl]="formControl" matNativeControl>
            <mat-option *ngFor="let option of myoptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
    </mat-form-field>
  `,
})
export class CustomFormlyDropdown extends FieldType<FieldTypeConfig> implements OnChanges {
    myoptions: any[] = [];

    ngOnInit() {
        const aux = this.props.options as any[] | Observable<any[]>;
        if (aux instanceof Observable) {
            aux.subscribe(options => {
                this.myoptions = options;
            });
        } else {
            this.myoptions = aux;
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['props'] && changes['props'].currentValue?.options) {
            this.myoptions = changes['props'].currentValue.options;
        }
    }
}